export default {
  data: function data() {
    return {
      options: {
        annotation: {
          drawTime: "afterDraw",
          events: ["mouseleave", "mouseenter"],
          annotations: []
        }
      }
    };
  },
  created: function created() {
    var _this = this;

    if (this.spec.lineVertical) {
      this.options.annotation.annotations = this.spec.lineVertical.map(function (element, index) {
        return _this.annotation(element, index);
      });
    }
  },
  methods: {
    annotation: function annotation(options, index) {
      var text = options.text,
          x = options.x;
      return {
        type: "line",
        mode: "vertical",
        scaleID: "x-axis-0",
        value: new Date(x).getTime(),
        borderColor: "rgba(0,0,255,0.3)",
        borderWidth: 3,
        borderDash: [5, 10],
        label: {
          content: text,
          enabled: true,
          position: "top",
          backgroundColor: "rgba(0,0,0,0.3)"
        },
        onMouseenter: function onMouseenter(e) {
          Object.assign(this.chartInstance.options.annotation.annotations[index], {
            borderColor: "rgba(0,0,255,0.8)"
          }, {
            label: {
              content: text,
              enabled: true,
              position: "top",
              backgroundColor: "rgba(0,0,0,0.8)"
            }
          });
          this.chartInstance.update();
        },
        onMouseleave: function onMouseleave(e) {
          Object.assign(this.chartInstance.options.annotation.annotations[index], {
            borderColor: "rgba(0,0,255,0.3)"
          }, {
            label: {
              content: text,
              enabled: true,
              position: "top",
              backgroundColor: "rgba(0,0,0,0.3)"
            }
          });
          this.chartInstance.update();
        }
      };
    }
  }
};